import React, { useEffect } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AOS from "aos";
import "aos/dist/aos.css";
import DesignDiamondRing from "./Components/DesignDiamondRing";
import InfoGrid from "./Components/InfoGrid";
import YourPleasure from "./Components/YourPleasure";
import InfoSection from "./Components/InfoSection";
import BestSellingProduct from "./Components/BestSellingProduct";
import ShopDiamondShape from "./Components/ShopDiamondShape";
import Insta from "./Components/Insta";
import SignupTo from "./Components/SignupTo";
import { ImageUrl } from "../../../../Helpers/request";

const ParisHome = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      // disable: 'mobile'
    });
  }, []);

  return (
    <>
      <div className="LandingPageShocase ParisThemeHome">
        <DesignDiamondRing />
        {/* <BannerSlider /> */}
        <InfoGrid />
        <YourPleasure />
        <InfoSection DesktopLeftImg={`${ImageUrl}theme/paris/about_lab.jpg`} MobileLeftImg={`${ImageUrl}theme/paris/mob_about_lab.jpg`} OverLine="BUY LAB GROWN DIAMONDS" Heading="Lab Grown Diamonds." Para="A diamond is a diamond, whether pulled from the earth or grown in a lab." Url="/diamonds/lab" />
        <BestSellingProduct />
        <InfoSection DesktopLeftImg={`${ImageUrl}theme/paris/guarantee.jpg`} MobileLeftImg={`${ImageUrl}theme/paris/mob_guarantee.jpg`} OverLine="EXPERIENCE MATTERS" Heading="DIAMOND EARRINGS" Para="With a Lifetime Manufacturing Defect Warranty, Price Match Guarantee, 30-day return policy and U.S. craftsmanship, you can be confident in each and every purchase." Url="/diamonds/earrings" />
        <ShopDiamondShape />
        <Insta />
        <SignupTo />
      </div>
    </>
  );
};

export default ParisHome;
